import React from "react";
import UserContact from "../../../../components/userContact/userContact";
import { useSelector } from "react-redux";
import SectionContainer from "../../../../components/sectionContainer/sectionContainer";
import styles from "./../membership.module.css";

function getTopThreeMembers(data) {
  if (!data && !data.length) return [];
  return data.sort((a, b) => b.revenueValue - a.revenueValue).slice(0, 3);
}

const ExpiredMembershipsContacts = () => {
  const { membersAtRiskRawDataLink, membersAtRiskNumber, membersAtRisk } = useSelector(
    (state) => state.membership.membersAtRisk
  );
  return membersAtRiskNumber > 0 ? (
    <div className={styles.riskMembers}>
      <SectionContainer
        title="At Risk Members you should contact"
        toolTip="We have found active members who are big spenders at your business that have recently stopped attending."
      >
        <UserContact
          membersAtRiskRawDataLink={membersAtRiskRawDataLink}
          showDetails
          membersAtRiskNumber={membersAtRiskNumber}
          total={membersAtRiskNumber}
          data={getTopThreeMembers(membersAtRisk)}
        />
      </SectionContainer>
    </div>
  ) : (
    <div className="error error--medium">No At Risk Members found</div>
  );
};

export default ExpiredMembershipsContacts;
